/**
 * isTimestampShaped
 *
 * Duck-types a Firestore Timestamp for `canonicalizeFormDeriveValue` and
 * `formDeriveValuesMatch`. `instanceof` is unusable — the client and admin SDKs
 * export different Timestamp classes — and so is enumeration: an admin
 * Timestamp's own keys are `_seconds`/`_nanoseconds` while the client's are
 * `seconds`/`nanoseconds`, and only the prototype getters read alike on both.
 * Every caller must reach the pair through this predicate, never `Object.keys`,
 * or the same value canonicalizes differently in react and in functions.
 */

import { isRecordValue } from './isRecordValue';

function isTimestampShaped(value: unknown): value is { seconds: number; nanoseconds: number } {
  return (
    isRecordValue(value) &&
    typeof value.seconds === 'number' &&
    typeof value.nanoseconds === 'number'
  );
}

export { isTimestampShaped };
